export default function SpringJumperIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="spring-jumper-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#9FD8FF" />
          <stop offset="1" stopColor="#FFF1DC" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="12" fill="url(#spring-jumper-sky)" />
      <circle cx="12" cy="14" r="5" fill="#fff" opacity=".8" />
      <circle cx="19" cy="12" r="6" fill="#fff" opacity=".8" />
      <rect x="6" y="52" width="26" height="7" rx="3.5" fill="#FFC857" stroke="#C98A1E" strokeWidth="2" />
      <rect x="36" y="40" width="22" height="7" rx="3.5" fill="#B48CFF" stroke="#6E45C9" strokeWidth="2" />
      <path d="M22 51l4-2-4-2 4-2-4-2M34 51l4-2-4-2 4-2-4-2" stroke="#7A8394" strokeWidth="2" fill="none" strokeLinejoin="round" />
      <circle cx="30" cy="30" r="13" fill="#FF7F8A" stroke="#6B1F3A" strokeWidth="2.5" />
      <ellipse cx="25" cy="29" rx="3.5" ry="4.2" fill="#fff" />
      <ellipse cx="35" cy="29" rx="3.5" ry="4.2" fill="#fff" />
      <circle cx="26" cy="30" r="1.8" fill="#231942" />
      <circle cx="36" cy="30" r="1.8" fill="#231942" />
      <path d="M27 35q3 3 6 0" stroke="#6B1F3A" strokeWidth="2" fill="none" strokeLinecap="round" />
      <path d="M30 17q-1-7 6-8q-1 5-6 8z" fill="#FFD166" stroke="#6B1F3A" strokeWidth="1.5" />
    </svg>
  );
}
